import { type ReactNode } from 'react';

import styles from './ListWithContentLayout.module.scss';

interface IListWithContentLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

function ListWithContentLayout({ sidebar, children }: IListWithContentLayoutProps) {
  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>{sidebar}</div>
      <div className={styles.separator} />
      <div className={styles.formContainer}>{children}</div>
    </div>
  );
}

export default ListWithContentLayout;
